<span>press 'c' to chat</span>
<div class="incoming">
  <app-message-line *ngFor="let msg of incoming" [msg]="msg"></app-message-line>
</div>
